import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
//style
import "./assets/css/normalize.css";

createApp(App).use(router).mount('#app')
